/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { LiquidityAddOptions, LiquidityAddResponses } from '../types/LiquidityAdd'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Add liquidity to a pool
 * {@link /v1/liquidity/pool/:pool_id/add}
 */
export function liquidityAdd<ThrowOnError extends boolean = true>(
  options: Options<LiquidityAddOptions, ThrowOnError>,
): Unwrappable<RequestResult<LiquidityAddResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/liquidity/pool/{pool_id}/add',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LiquidityAddResponses, ThrowOnError>>,
  )
}
